import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import SidebarSeguimiento from "../../../components/sidebar-seguimiento";
import DetailPanelSeguimiento from "../../../components/detail-panel-seguimiento";
import MapaSeguimientoGoogle from "./mapa-seguimiento-google";
import moment from "moment";
import { ChevronRight } from "lucide-react";
import { obtenerListaSeguimiento, obtenerDetalleSeguimiento } from "../../../api/api-seguimiento";
import { sharedNextPage } from "../../../utils/shared-functions";
import { obtenerPuntoActualVehiculo, } from "../../../api/gestion-dts/gestion";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../../usuarios/gestionar-rol-usuario-web/pages-const";

export default function MapaSeguimientoPage
  () {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  const { t } = useTranslation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  // const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  // const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  // const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  //   const [rowsData, setRowsData] = useState([]);
  const [itemsList, setItemsList] = useState([]);
  const [mapMarkers, setMapMarkers] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const sidebarRef = useRef(null);
  const [sidebarWidth, setSidebarWidth] = useState(0);
  const [detailPanelVisible, setDetailPanelVisible] = useState(false);
  const [detailItems, setDetailItems] = useState([]);

  const [itemSelected, setItemSelected] = useState(null);
  const [mapCenter, setMapCenter] = useState(null);
  const [mapZoom, setMapZoom] = useState(12);
  const [geocercasSelected, setGeocercasSelected] = useState(null);
  const [tipoClientesSelected, setTipoClientesSelected] = useState(null);

  const [vehiculoSelected, setVehiculoSelected] = useState(null);
  const [puntoActual, setPuntoActual] = useState(null);

  // const [listaEntregas, setListaEntregas] = useState([]);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

  const [btnConfiguracionPlaca, setBtnConfiguracionPlaca] = useState(false);
  const [btnFiltros, setBtnFiltros] = useState(false);
  const [btnConfiguracionPedido, setBtnConfiguracionPedido] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  // Fetch current vehicle position every 15 seconds when a vehicle is selected
  useEffect(() => {
    if (vehiculoSelected === undefined || vehiculoSelected === null || vehiculoSelected === "") return;
    const fetchPuntoActual = async () => {
      try {
        const punto = await obtenerPuntoActualVehiculo(vehiculoSelected);
        // console.log('punto=>', punto);
        setPuntoActual(punto);
      } catch (_) {
        setPuntoActual(null);
      }
    };
    fetchPuntoActual();
    const intervalId = setInterval(fetchPuntoActual, 15000);
    return () => clearInterval(intervalId);
  }, [vehiculoSelected]);

  // Update sidebar width when it changes
  useEffect(() => {
    if (sidebarVisible && sidebarRef.current) {
      const updateWidth = () => {
        if (sidebarRef.current) {
          const width = sidebarRef.current.offsetWidth;
          if (width > 0) {
            setSidebarWidth(width);
          }
        }
      };

      // Use ResizeObserver for accurate width tracking
      let resizeObserver;
      if (window.ResizeObserver && sidebarRef.current) {
        resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            const width = entry.contentRect.width;
            if (width > 0) {
              setSidebarWidth(width);
            }
          }
        });
        resizeObserver.observe(sidebarRef.current);
      }

      // Immediate update
      updateWidth();
      // Also try after a short delay to ensure DOM is ready
      const timer = setTimeout(updateWidth, 10);
      window.addEventListener('resize', updateWidth);

      return () => {
        clearTimeout(timer);
        window.removeEventListener('resize', updateWidth);
        if (resizeObserver) {
          resizeObserver.disconnect();
        }
      };
    } else {
      setSidebarWidth(0);
    }
  }, [sidebarVisible]);


  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnConfiguracionPlaca(true);
        setBtnFiltros(true);
        setBtnConfiguracionPedido(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          // console.log('permisos');
          // console.log(permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find(p => p.id === 6);
            if (manage !== undefined && manage !== null) {
              const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.SEGUIMIENTO_MAPA);
              // console.log('permisosPage');
              // console.log(permisosPage);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnConfiguracionPlaca = permisosPage.acciones.find(a => a.value === 'btn_configuracion_placa');
              const permisoBtnFiltros = permisosPage.acciones.find(a => a.value === 'btn_filtros');
              const permisoBtnConfiguracionPedido = permisosPage.acciones.find(a => a.value === 'btn_configuracion_pedido');
              setBtnConfiguracionPlaca(permisoBtnConfiguracionPlaca?.checked);
              setBtnFiltros(permisoBtnFiltros?.checked);
              setBtnConfiguracionPedido(permisoBtnConfiguracionPedido?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {
        const listaSeguimiento = await obtenerListaSeguimiento({ fechaEntrega: selectedDate });
        // console.log('listaSeguimiento');
        // console.log(listaSeguimiento);
        setItemsList(listaSeguimiento);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  // Handle date change
  const handleDateChange = async (date) => {
    try {
      // console.log('handleDateChange');
      // console.log(date);
      reset();
      setSelectedDate(date);
      setProcessingVisible(true);
      const listaSeguimiento = await obtenerListaSeguimiento({ fechaEntrega: date });
      // console.log('listaSeguimiento');
      // console.log(listaSeguimiento);
      setItemsList(listaSeguimiento);
    } catch (err) {
      console.log('handleDateChange err');
      console.log(err);
      setItemsList([]);
      showToast(t("alert_error_al_cargar_datos") || "Error al cargar datos", "error");
    } finally {
      setProcessingVisible(false);
    }
  };

  // Handle item click from sidebar
  const handleItemClick = async (item) => {
    try {
      // console.log('handleItemClick');
      // console.log(item);
      setPuntoActual(null);
      setItemSelected(item);
      setVehiculoSelected(item.valuePlaca);
      // const puntoActual = await obtenerPuntoActualVehiculo(item.valuePlaca);
      // console.log('puntoActual=>', puntoActual);
      // setPuntoActual(puntoActual);
      setProcessingVisible(true);
      setDetailPanelVisible(true);
      const data = await obtenerDetalleSeguimiento({ idPedido: item.id });
      // console.log('obtenerDetalleSeguimiento');
      // console.log(data);
      setDetailItems(data);
      // Update map markers with all items that have coordinates
      if (Array.isArray(data) && data.length > 0) {
        const markers = data
          .filter(item => item.latitud && item.longitud)
          .map((item, index) => ({
            lat: parseFloat(item.latitud),
            lng: parseFloat(item.longitud),
            title: item.cliente || "Item",
            infoWindow: item.cliente || "ItemView",
            color: item.color || "#000000",
            index: index + 1,
          }));
        setMapMarkers(markers);
        setMapCenter(null);
        setMapZoom(15);
      } else {
        setMapMarkers([]);
        setMapCenter(null);
        setMapZoom(12);
      }
    } catch (err) {
      console.log('handleItemClick err');
      console.log(err);
      showToast(t("alert_error_al_cargar_datos") || "Error al cargar datos", "error");
      setDetailItems([]);
      setMapMarkers([]);
      setVehiculoSelected(null);
      setPuntoActual(null);
    } finally {
      setProcessingVisible(false);
    }
  };

  // Handle item click from detail panel
  // Flow: handleItemClickCliente -> onItemClick -> handleDetailItemClick
  // This method centers the map on the clicked item's coordinates
  const handleDetailItemClick = (item) => {
    // console.log('handleDetailItemClick');
    // console.log(item);
    // Move the map to the clicked item's coordinates
    if (item.latitud && item.longitud) {
      const lat = parseFloat(item.latitud);
      const lng = parseFloat(item.longitud);

      // Check if coordinates are valid numbers
      if (!isNaN(lat) && !isNaN(lng)) {
        // Update map center and zoom to focus on the clicked item
        setMapCenter({
          lat: lat,
          lng: lng
        });
        setMapZoom(16); // Zoom in closer when focusing on a specific item
      } else {
        console.warn('Invalid coordinates for item:', item);
      }
    } else {
      console.warn('Item does not have latitud/longitud properties:', item);
    }
  };

  const reset = async () => {
    setItemsList([]);
    setMapMarkers([]);
    setDetailItems([]);
    setItemSelected(null);
    setDetailPanelVisible(false);
    setMapCenter(null); // Reset map center
    setMapZoom(12); // Reset zoom
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleRuteoClick = () => {
    // console.log('handleRuteoClick');
    // console.log('itemSelected', itemSelected);
    // console.log('detailItems', detailItems);
    sharedNextPage("ruteo",
      {
        itemSelected: itemSelected,
        detailItems: detailItems
      }, history);
  };

  const fetchMarkerInfo = async (markerData) => {
    // console.log('fetchMarkerInfo');
    // console.log(markerData);
    return markerData.infoWindow;
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="h-screen flex flex-col overflow-hidden">
          <div className="flex-1 flex overflow-hidden relative">
            {/* Sidebar - 1/3 of screen */}
            <div
              ref={sidebarRef}
              className={`${sidebarVisible
                ? "w-1/3 min-w-[300px] max-w-[300px]"
                : "w-0"
                } flex-shrink-0 overflow-hidden relative`}
              style={{ transition: 'none' }}
            >
              {sidebarVisible && (
                <SidebarSeguimiento
                  items={itemsList}
                  selectedDate={selectedDate}
                  onDateChange={handleDateChange}
                  onItemClick={handleItemClick}
                  detailPanelVisible={detailPanelVisible}
                  onGeocercasChange={setGeocercasSelected}
                  onTipoClientesChange={setTipoClientesSelected}
                  showToast={showToast}
                  setProcessingVisible={setProcessingVisible}
                  setSidebarVisible={setSidebarVisible}
                  btnConfiguracionPlaca={btnConfiguracionPlaca}
                  btnFiltros={btnFiltros}
                />
              )}
            </div>

            {/* Map - Adjusts based on visible panels */}
            <div className={`${sidebarVisible && detailPanelVisible ? "w-1/3" : "flex-1"} min-w-0 relative`} style={{ zIndex: 1 }}>
              <MapaSeguimientoGoogle
                markers={mapMarkers}
                center={mapCenter || (mapMarkers.length > 0 ? {
                  lat: mapMarkers[0].lat,
                  lng: mapMarkers[0].lng
                } : null)}
                zoom={mapZoom}
                onMarkerClick={(marker) => {
                  // console.log("Marker clicked:", marker);
                }}
                onMapClick={(lat, lng) => {
                  console.log("Map clicked:", lat, lng);
                  console.log('detailItems', detailItems);
                }}
                fetchMarkerInfo={fetchMarkerInfo}
                puntoActual={puntoActual}
                detailItems={detailItems}
                fechaEntrega={selectedDate}
              />
            </div>

            {/* Detail Panel - 1/3 of screen */}
            <div
              className={`${detailPanelVisible
                ? "w-1/3"
                : "w-0"
                } flex-shrink-0 overflow-hidden relative`}
              style={{ transition: 'none' }}
            >
              {detailPanelVisible && (
                <DetailPanelSeguimiento
                  isOpen={detailPanelVisible}
                  showToast={showToast}
                  onClose={() => {
                    setDetailPanelVisible(false);
                  }}
                  items={detailItems}
                  onItemClick={handleDetailItemClick}
                  itemSelected={itemSelected}
                  geocercasSelected={geocercasSelected}
                  tipoClientesSelected={tipoClientesSelected}
                  setProcessingVisible={setProcessingVisible}
                  handleRuteoClick={handleRuteoClick}
                  selectedDate={selectedDate}
                  btnConfiguracionPedido={btnConfiguracionPedido}
                />
              )}
            </div>

            {/* Toggle Button - On left edge when sidebar is hidden */}
            {!sidebarVisible && (
              <button
                onClick={() => {
                  setSidebarVisible(true);
                }}
                className="absolute bg-white border border-gray-300 rounded-r-lg shadow-lg hover:shadow-xl transition-all duration-200 hover:bg-gray-50 flex items-center justify-center"
                style={{
                  height: '2.5rem',
                  width: '2.5rem',
                  top: '4.25rem',
                  transform: 'translateY(-50%)',
                  left: '0',
                  zIndex: 99999,
                  position: 'absolute',
                  pointerEvents: 'auto'
                }}
                aria-label={t("label_mostrar_sidebar") || "Mostrar sidebar"}
              >
                <ChevronRight className="h-5 w-5 text-gray-700" />
              </button>
            )}
          </div>

          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('MapaSeguimientoPage render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  };

  return render();
}
